import { t as toggleBooleanAttribute } from './toggleBooleanAttribute-Cp5m6OeZ.js';

class CollapsibleElement extends HTMLElement {
  /** @type {HTMLElement} */ #controller = this.querySelector('[aria-controls]');
  /** @type {HTMLElement} */ #target = this.#controller.ariaControlsElements[0];
  /** @type {boolean} */ #alwaysOpenDesktop = this.hasAttribute('data-always-open-desktop');

  connectedCallback() {
    this.#initDesktopAriaAttributes();
    this.#controller.addEventListener('click', () => this.#handleClick());
  }

  #initDesktopAriaAttributes() {
    if (!this.#alwaysOpenDesktop || !window.matchMedia('(min-width: 1024px)').matches) return;

    // Set aria attributes for desktop on init if always open
    toggleBooleanAttribute(this.#controller, 'aria-expanded', 'true');
    toggleBooleanAttribute(this.#target, 'aria-hidden', 'false');
  }

  #handleClick() {
    toggleBooleanAttribute(this.#controller, 'aria-expanded');
    toggleBooleanAttribute(this.#target, 'aria-hidden');
  }
}

customElements.define('collapsible-element', CollapsibleElement);
